<template>
  <div class="glyph-field">
    <span class="glyph-field-label">Chip icon</span>
    <div class="glyph-grid">
      <button type="button" class="glyph-btn is-text" :class="{ 'is-selected': isNone }"
        title="No glyph" @click="select(TAG_GLYPH_NONE)">None</button>
      <button type="button" class="glyph-btn" :class="{ 'is-selected': isDot }"
        title="Coloured dot" @click="select(TAG_GLYPH_DOT)">
        <span class="dot-preview" :style="{ background: color }"></span>
      </button>
      <button v-for="ic in icons" :key="ic" type="button" class="glyph-btn"
        :class="{ 'is-selected': modelValue === ic }" :title="ic" @click="select(ic)">
        <v-icon size="18" :color="modelValue === ic ? color : '#cfd8dc'">{{ ic }}</v-icon>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { TAG_ICONS, TAG_GLYPH_DOT, TAG_GLYPH_NONE } from '@/constants/tagOptions';
import { DEFAULT_MARKER_COLOR } from '@/lib/markerShapeFactory';

const props = defineProps({
  modelValue: { type: String, default: null }, // null/'dot' = dot, 'none' = none, else mdi name
  color: { type: String, default: DEFAULT_MARKER_COLOR },
});
const emit = defineEmits(['update:modelValue']);

const icons = TAG_ICONS;
const isNone = computed(() => props.modelValue === TAG_GLYPH_NONE);
const isDot = computed(() => !props.modelValue || props.modelValue === TAG_GLYPH_DOT);

function select(value) {
  emit('update:modelValue', value);
}
</script>

<style scoped>
.glyph-field { display: flex; flex-direction: column; gap: 8px; }
.glyph-field-label { font-size: 0.78rem; color: #b0bec5; font-weight: 600; }
.glyph-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.glyph-btn {
  min-width: 34px; height: 34px; padding: 0 8px; border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.12); background: rgba(255, 255, 255, 0.03);
  cursor: pointer; display: inline-flex; align-items: center; justify-content: center;
  color: #cfd8dc; font: inherit; font-size: 0.78rem; font-weight: 600;
  transition: transform 0.1s ease, border-color 0.1s ease, background 0.1s ease;
}
.glyph-btn:hover { transform: scale(1.08); background: rgba(255, 255, 255, 0.06); }
.glyph-btn.is-selected { border-color: #fff; box-shadow: 0 0 0 2px rgba(100, 255, 218, 0.5); }
.glyph-btn.is-text { letter-spacing: 0.02em; }
.dot-preview { width: 10px; height: 10px; border-radius: 50%; }
</style>
